import React from 'react';
import { Box } from '@chakra-ui/react';
import { HelmetProvider } from 'react-helmet-async';
import { Home } from './pages/Home';
import { FontLoader } from './components/FontLoader';
export function App() {
  return <HelmetProvider data-id="element-0">
      <FontLoader data-id="element-1" />
      <Box width="100%" minHeight="100vh" bg="gray.50" data-id="element-2">
        <Home data-id="element-3" />
      </Box>
    </HelmetProvider>;
}